const OVERLAY_CONFIG = {
  connecting: {
    title: "Preparing WhatsApp setup",
    subtitle: "Creating your Blutec Ping business account before WhatsApp signup…",
    steps: [
      "Creating Blutec Ping business for your account",
      "Preparing embedded signup",
    ],
  },
  adding: {
    title: "Adding via Facebook",
    subtitle: "Completing embedded signup and configuring your number…",
    steps: [
      "Exchanging authorization code with Meta",
      "Fetching WhatsApp Business account details",
      "Activating number on Blutec Ping",
      "Configuring webhooks",
    ],
  },
  "adding-manual": {
    title: "Activating WhatsApp Number",
    subtitle: "Running automated setup — your number is being activated on Blutec Ping.",
    steps: [
      "Verifying access token with Meta",
      "Activating number on Blutec Ping",
      "Configuring webhooks",
      "Saving account to Blutec Ping",
    ],
  },
  disconnecting: {
    title: "Disconnecting Number",
    subtitle: "Removing this WhatsApp number from your account…",
    steps: [
      "Updating account settings",
      "Removing local configuration",
      "Finalizing disconnection",
    ],
  },
};

const WhatsappConnectOverlay = ({ type }) => {
  if (!type) return null;

  const config = OVERLAY_CONFIG[type] || {
    title: "Processing…",
    subtitle: "Please wait",
    steps: [],
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9999] flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full mx-4">
        <div className="flex flex-col items-center gap-6">
          <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-200 border-t-[#17181b]" />
          <div className="text-center w-full">
            <h3 className="text-xl font-bold text-gray-900 mb-2">{config.title}</h3>
            <p className="text-sm text-gray-600 mb-5">{config.subtitle}</p>
            <div className="space-y-2.5 text-left">
              {config.steps.map((label) => (
                <div key={label} className="flex items-center gap-2 text-xs text-gray-600">
                  <div className="w-2 h-2 rounded-full bg-[#17181b] animate-pulse flex-shrink-0" />
                  <span>{label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsappConnectOverlay;
